<template>
    <div
        class="container"
        id="itb-breadcrumbs"
        :class="{
            'itb-breadcrumps-loggedin': styleAdjusted,
            'd-flex align-items-center flex-wrap':
                $route.name == 'graphicDetail',
            'itb-adjust-breadcrumb-margin-top': mustAdjustTopMargin,
            'itb-epdm-panelling-breadcrumb-top-margin':
                $route.path == '/other-products/epdm-panelling',
        }"
        v-if="breadCrumbs && appParams && appParams.staticTranslations"
    >
        <span v-for="(crumb, index) in breadCrumbs">
            <router-link
                :to="
                    crumb.pathForTranslation
                        ? '/' +
                          appParams.staticTranslations[crumb.pathForTranslation]
                        : crumb.path
                "
                v-if="crumb.path || crumb.pathForTranslation"
                >{{
                    crumb.nameForTranslation
                        ? appParams.staticTranslations[crumb.nameForTranslation]
                        : crumb.name
                }}
            </router-link>
            <span :class="{ 'mr-5': $route.name == 'graphicDetail' }" v-else
                >{{
                    crumb.nameForTranslation
                        ? appParams.staticTranslations[crumb.nameForTranslation]
                        : crumb.name
                }}
            </span>
            <span
                v-if="index < breadCrumbs.length - 1"
                class="itb-separator"
            ></span>
        </span>
        <button
            class="itb-back-button mb-1"
            v-if="$route.name == 'graphicDetail'"
            @click="goBack"
        >
            <i class="demo-icon icon-left-open" style="font-weight: 400"></i>
            {{
                appParams && appParams.staticTranslations
                    ? appParams.staticTranslations["general.go_back"]
                    : "general.go_back"
            }}
        </button>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    props: {
        host: String,
    },

    data() {
        return {
            graphicSubcategory2Name: "",
        };
    },

    computed: {
        ...mapGetters({
            params: "getPageParams",
            isLoggedIn: "getClientLogged",
            appParams: "getAppParams",
        }),

        breadCrumbs() {
            var breadCrumbs;
            if (this.params) {
                breadCrumbs = this.params.page_breadcrumbs;
            } else {
                breadCrumbs = [];
            }
            return breadCrumbs;
        },

        styleAdjusted() {
            if (
                (this.$route.name == "graphicsByCategory" && this.isLoggedIn) ||
                (this.$route.name == "graphicDetail" && this.isLoggedIn) ||
                (this.$route.name == "graphicsByCategorySubcategory" &&
                    this.isLoggedIn)
            ) {
                return true;
            } else {
                return false;
            }
        },

        currentTitle() {
            let title = "";
            let breadCrumbsWithoutHome = structuredClone(this.breadCrumbs);
            let routeNames = [];
            if (
                this.breadCrumbs &&
                this.breadCrumbs.length > 0 &&
                this.appParams.staticTranslations
            ) {
                if ((this.breadCrumbs[0].path = "/")) {
                    breadCrumbsWithoutHome.shift();
                }
                breadCrumbsWithoutHome.forEach((element, index) => {
                    if (
                        element.hasOwnProperty("nameForTranslation") &&
                        element.nameForTranslation
                    ) {
                        routeNames.push(
                            this.appParams.staticTranslations[
                                element.nameForTranslation
                            ]
                        );
                    } else if (element.hasOwnProperty("name") && element.name) {
                        routeNames.push(element.name);
                    }
                });

                if (
                    this.$route.name == "graphicDetail" &&
                    this.graphicSubcategory2Name &&
                    !this.$store.state.isLoggedIn
                ) {
                    routeNames.splice(3, 0, this.graphicSubcategory2Name);
                }

                routeNames.reverse();

                title = routeNames.join(" - ") + " | " + this.host;
            } else {
                title = this.host;
            }

            return title;
        },

        mustAdjustTopMargin() {
            if (
                this.$route.path == "/cookies-policy" ||
                this.$route.path == "/privacy-policy" ||
                this.$route.path == "/settings" ||
                this.$route.path == "/cart" ||
                this.$route.path.startsWith("/saved-carts") ||
                (this.$route.name == "graphicsByCategory" && this.isLoggedIn) ||
                (this.$route.name == "graphicDetail" && this.isLoggedIn) ||
                (this.$route.name == "graphicsByCategorySubcategory" &&
                    this.isLoggedIn)
            ) {
                return false;
            } else {
                return true;
            }
        },

        // specificClassByRoute() {
        //     let className = "";
        //     if (this.$route.path == "/other-products/epdm-panelling") {
        //         className = "itb-epdm-panelling-breadcrumb-top-margin";
        //     }
        //     return className;
        // },
    },

    watch: {
        currentTitle() {
            this.changeTitle();
            this.getGraphicSubcategory2Name();
            this.$emit("updatePageTitle", this.currentTitle);
        },
    },

    created() {
        this.changeTitle();
        this.getGraphicSubcategory2Name();
        this.$emit("updatePageTitle", this.currentTitle);
    },

    methods: {
        goBack() {
            this.$router.back();
        },

        getHost() {
            axios
                .get("/get-host")
                .then((response) => {
                    this.host = response.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        changeTitle() {
            document.title = this.currentTitle;
        },

        getGraphicSubcategory2Name() {
            if (this.$route.name == "graphicDetail") {
                let subcategoryId =
                    this.$route.params.subcategory2Alias.split("-")[0];
                axios
                    .get("/get-graphic-subcategory-2-name/" + subcategoryId)
                    .then((response) => {
                        this.graphicSubcategory2Name = response.data;
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
    },
};
</script>
